import { render, staticRenderFns } from "./TabellaImport.vue?vue&type=template&id=4c4b2f8b&scoped=true&"
import script from "./asset_tabella/index.js?vue&type=script&lang=js&"
export * from "./asset_tabella/index.js?vue&type=script&lang=js&"
import style0 from "./asset_tabella/style.css?vue&type=style&index=0&id=4c4b2f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b2f8b",
  null
  
)

export default component.exports